import { FC, useContext, useEffect, useState } from "react";
import "./LicenseList.css";
import { Context } from "../../../index";
import WidgetContainer from "../../UiLib/WidgetContainer/WidgetContainer";
import LicenseInfo from "../LicenseInfo/LicenseInfo";
import ContainerWithOverlay from "../../UiLib/ContainerWithOverlay/ContainerWithOverlay";
import ActivateLicenseSetting from "../ActivateLicense/ActivateLicenseSetting";
import RenewLicense from "../RenewLicense/RenewLicense";
import { ILicenseViewVersion } from "../../../common/api_interfaces/license/ILicenseView";

const LicenseList: FC = () => {
    const [allLicenses, setAllLicenses] = useState<ILicenseViewVersion[]>([]);
    const [showActivatePopup, setShowActivatePopup] = useState<boolean>(false);
    const [showRequestPopup, setShowRequestPopup] = useState<boolean>(false);
    const { store } = useContext(Context);

    // Инициалихзация лицензий
    useEffect(() => {
        (async () => {
            try {
                const licenses = (await store.licenseService.getAllLicenses()).data;
                setAllLicenses(licenses);
            } catch (error) {
                console.error(error);
            }
        })();
    }, []);

    return (
        <div style={{ width: "100%", display: "flex", flexDirection: "column", height: "100%" }}>
            {showActivatePopup ? (
                <div>
                    <ContainerWithOverlay onOverlayClick={() => {}}>
                        <ActivateLicenseSetting onClose={() => setShowActivatePopup(false)} />
                    </ContainerWithOverlay>
                </div>
            ) : null}
            {showRequestPopup ? (
                <div className="license-request-container">
                    <ContainerWithOverlay onOverlayClick={() => {}} style={{zIndex: 10000}}>
                        <RenewLicense onClose={() => setShowRequestPopup(false)} allLicenses={allLicenses} />
                    </ContainerWithOverlay>
                </div>
            ) : null}
            <div className="license-block-left-content">
                <button className="button-activate p_14" onClick={() => setShowActivatePopup(true)}>
                    Активировать
                </button>
                <button className="button-getlicense p_14" onClick={() => setShowRequestPopup(true)}>
                    Запросить лицензию
                </button>
            </div>
            <div className="license-block-current-license">
                {allLicenses.map((license, index) => (
                    <div id={`${index}_1`}>
                        <WidgetContainer className={"license-block"}>
                            <LicenseInfo license={license} index={index} />
                        </WidgetContainer>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LicenseList;
